// components/Common/HoverInfo.js
import React, { useRef, useState, useEffect } from "react";
import "./HoverInfo.css";

const HoverInfo = ({ label, styles = {}, activeStyles = {}, ...rest }) => {
  const spanRef = useRef(null);
  const [isButtonActive, setIsButtonActive] = useState(false);

  useEffect(() => {
    // climb from the span up to find the <button> (or element with .hover-info-button)
    let btn = spanRef.current?.parentElement;
    while (btn && !(btn.tagName === "BUTTON" || btn.classList.contains("hover-info-button"))) {
      btn = btn.parentElement;
    }
    if (!btn) return;

    const handleDown   = () => setIsButtonActive(true);
    const handleUp     = () => setIsButtonActive(false);
    const handleLeave  = () => setIsButtonActive(false);

    // mouse
    btn.addEventListener("mousedown", handleDown);
    btn.addEventListener("mouseup",   handleUp);
    btn.addEventListener("mouseleave", handleLeave);
    // touch
    btn.addEventListener("touchstart",  handleDown);
    btn.addEventListener("touchend",    handleUp);
    btn.addEventListener("touchcancel", handleLeave);

    return () => {
      btn.removeEventListener("mousedown", handleDown);
      btn.removeEventListener("mouseup",   handleUp);
      btn.removeEventListener("mouseleave", handleLeave);
      btn.removeEventListener("touchstart",  handleDown);
      btn.removeEventListener("touchend",    handleUp);
      btn.removeEventListener("touchcancel", handleLeave);
    };
  }, []);

  return (
    <span
      ref={spanRef}
      className="hover-label"
      style={{
        ...styles,
        ...(isButtonActive ? activeStyles : {}),
      }}
      {...rest}
    >
      {label}
    </span>
  );
};

export default HoverInfo;
